import { AppState } from '@app/store';
import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { loadFromLocalStorage, saveToLocalStorage } from './local-storage';
import { SettingsAction } from '../actions/settings.actions';

export function settingsSyncMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    if (action.type === INIT || action.type === UPDATE) {
      const settingsLocalState = loadFromLocalStorage();
      if (settingsLocalState && state) {
        return reducer({ ...state, settings: { ...state.settings, ...settingsLocalState } }, action);
      }
    }
    const nextState = reducer(state, action);

    if (action.type === SettingsAction.SET_USER_SETTINGS) {
      saveToLocalStorage(nextState.settings);
    }
    return nextState;
  };
}
